import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import * as ActionsNews from '../../redux/modules/news';
import * as ActionsText from '../../redux/modules/text';
import ListEntity from '../../components/ListEntity/List';
import Notice from '../../components/ListEntity/Entities/Notice';
import Modal from '../../components/Render/Modal/Modal';
import FormNotice from '../../forms/notice';
import FormArticle from '../../forms/article';
import LayoutSection from '../../components/layout-section';
import GenericTextForm from '../../forms/generic-text/index';
import TextSection from '../../components/ListEntity/TextSection';

const today = moment(new Date()).format('YYYY-MM-DD');

class General extends PureComponent {
  state = { isOpenNews: false, isOpenArticles: false };

  getData() {
    this.props.getAction();
    this.props.getTextAction('news');
  }

  componentWillMount() {
    this.getData();
  }

  removeNotice(info) {
    if (info.id > 0) {
      const { getAction, delAction } = this.props;
      delAction(info.id).then(() => {
        getAction();
      });
    }
  }

  toggleOpenNewsModal(data = {
    is_soon: false,
    start_date: today,
    end_date: today
  }) {
    this.setState({ isOpenNews: !this.state.isOpenNews, data });
  }

  toggleOpenArticlesModal(form = 'articles', data = {}) {
    this.setState({ isOpenArticles: !this.state.isOpenArticles, form, data });
  }

  render() {
    const { news, text } = this.props;
    return (
      <div className="contacts-container container">

        <LayoutSection
          isFetching={text.isFetching}
          title="Events">
          <TextSection
            editAction={() => {
              this.toggleOpenArticlesModal('text', text.values);
            }}>
            <div dangerouslySetInnerHTML={{ __html: text.values.body }}></div>
          </TextSection>
        </LayoutSection>

        <LayoutSection
          isFetching={news.isFetching}
          title="">
          <ListEntity
            number={3}
            component={Notice}
            removeAction={(index) => {
              this.removeNotice(news.values[index]);
            }}
            editAction={(index) => {
              this.toggleOpenNewsModal(news.values[index]);
            }}
            addAction={() => {
              this.toggleOpenNewsModal();
            }}
            values={news.values}/>
        </LayoutSection>

        <div className="contacts-container__modal">
          <Modal
            toogle={this.toggleOpenNewsModal.bind(this)}
            isOpen={this.state.isOpenNews}>
            <FormNotice
              defaultValues={this.state.data}
              close={this.toggleOpenNewsModal.bind(this)}
              contactType={this.state.contactType}/>
          </Modal>

          <Modal
            toogle={this.toggleOpenArticlesModal.bind(this)}
            isOpen={this.state.isOpenArticles}>

            {
              this.state.form === 'text' ?
                <GenericTextForm
                  numberOfImages={0}
                  section="news"
                  close={this.toggleOpenArticlesModal.bind(this)}
                  defaultValues={this.state.data}/>
                :
                <FormArticle
                  defaultValues={this.state.data}
                  close={this.toggleOpenArticlesModal.bind(this)}
                  contactType={this.state.contactType}/>
            }
          </Modal>
        </div>
      </div>
    );
  }
}

General.propTypes = {};
General.defaultProps = {};

export default connect(
  (state) => {
    return {
      news: state.news,
      text: state.text
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: ActionsNews.get,
        delAction: ActionsNews.del,
        getTextAction: ActionsText.get,
      }, dispatch);
  }
)(General);



// WEBPACK FOOTER //
// ./src/containers/events/Events.js